/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Section_EngagementInputs */

const fr_membership_section_engagement = /** @type {(inputs: Membership_Section_EngagementInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engagement restant`)
};

/**

* @param {Membership_Section_EngagementInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_section_engagement = /** @type {((inputs?: Membership_Section_EngagementInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Section_EngagementInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_section_engagement(inputs)
});